import { CheckCircle2 } from 'lucide-react';

export const PUBLIC_MOVEMENT_CLOSED_MESSAGE = 'Movimento finalizado. Este link público não está mais disponível.';

export function isPublicMovementClosedMessage(value = '') {
  const text = String(value || '').toLowerCase();
  return text.includes('movimento finalizado') || text.includes('movimento encerrado') || text.includes('link público não está mais disponível');
}

export function PublicMovementClosedScreen({ message = PUBLIC_MOVEMENT_CLOSED_MESSAGE, testIdPrefix = 'public-movement-closed' }) {
  return <main className="min-h-screen bg-emerald-950 px-4 py-10 text-white" data-testid={`${testIdPrefix}-page`}>
    <section className="mx-auto flex min-h-[70vh] w-full max-w-md flex-col items-center justify-center text-center" data-testid={`${testIdPrefix}-section`}>
      <div className="flex h-16 w-16 items-center justify-center rounded-3xl bg-white/10 text-emerald-100 shadow-xl" data-testid={`${testIdPrefix}-icon`}><CheckCircle2 className="h-8 w-8" /></div>
      <h1 className="mt-5 text-3xl font-black" data-testid={`${testIdPrefix}-title`}>Movimento finalizado</h1>
      <p className="mt-3 text-sm font-semibold leading-relaxed text-emerald-100" data-testid={`${testIdPrefix}-message`}>{message}</p>
    </section>
  </main>;
}